import script from "./PlanShow.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanShow.vue?vue&type=script&setup=true&lang=js"

import "./PlanShow.vue?vue&type=style&index=0&id=7ac90cd2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac90cd2"]])

export default __exports__